export const CAMPAING_FILE_TYPE_ACCEPTEDS: string[] = ['csv'];

export const CAMPAING_FILE_TYPE_DEFAULT = 'csv';
